import { Theme } from '@mui/material'

import useSharedStyles from '../shared.styles'

const useStyles = {
  screen: (isMobile: boolean) => ({
    ...useSharedStyles.screen(isMobile),
    paddingBottom: isMobile ? 4 : 3,
  }),
  form: {
    ...useSharedStyles.form,
    maxWidth: 358,
  },
  intro: (isMobile: boolean) => ({
    ...useSharedStyles.intro(isMobile),
    gap: 0.5,
  }),
  phoneOptions: {
    flexDirection: 'column',
    gap: 2.75,
    marginTop: 3,
  },
  phoneOption: (theme: Theme) => ({
    alignItems: 'flex-start',
    width: '100%',
    minHeight: 100,
    margin: 0,
    padding: 1,
    border: `1px solid ${theme.palette.ui.outlineVariant}`,
    borderRadius: 2,
    backgroundColor: theme.palette.common.white,
    '& .MuiFormControlLabel-label': {
      width: '100%',
    },
    '&:has(.Mui-checked)': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  }),
  optionContent: {
    flexDirection: 'column',
    minWidth: 0,
  },
  optionLabel: (theme: Theme) => ({
    minHeight: 20,
    color: theme.palette.primary.main,
    fontWeight: 600,
    marginTop: 1,
  }),
  phoneType: {
    marginTop: 1,
  },
  phoneNumber: {
    fontWeight: 600,
    lineHeight: 1.3,
  },
  submitContainer: () => ({
    ...useSharedStyles.submitContainer(),
    paddingBottom: 0,
  }),
  continueButton: {
    minWidth: 88,
    minHeight: 40,
    borderRadius: 20,
    textTransform: 'none',
  },
}

export default useStyles
